import Api from '@/services/Api'

export default {
  login (params) {
    return Api().post('login', params)
  },
  logout (data) {
    return Api().get('logout')
  },
  sesion () {
    return Api().get('sesion')
  },
  register (params) {
    return Api().post('register', params)
  },
  getUserByEmail (params) {
    return Api().post('vs', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/performanceService.js